import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
// import { useSpring, animated as a, to } from 'react-spring'
// import useWindowScroll from '@react-hook/window-scroll'
// import useScrollWidth from '../../helpers/useScroll'
// import { withStyles } from '@material-ui/core/styles';
import MetaTags from 'react-meta-tags';
import GeneralStyles from '../../styles/GeneralStyles';
// import Map from '../../assets/images/Map.jpg';
import SvgMap from '../../assets/images/svg/svgMap';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CircularProgress from '@material-ui/core/CircularProgress';


import styled from "styled-components";

const useGeneralStyles = GeneralStyles;

const Main = styled.main``;

const HorizontalSection = styled.section`
position: relative;
width: 100%;
min-height: 100%;
`;

const CardsContainer = styled.div`
position: relative;
height: 100%;
padding: 0 0 0 0px;
display: flex;
flex-flow: row nowrap;
justify-content: flex-start;
align-items: center;
`;

// const SampleCards = React.memo(() =>
//     Array(1)
//         .fill(0)
//         .map((_e, i) =>
//             <div style={{
//                 position: 'relative',
//                 height: '100%',
//                 width: '1150px',
//                 flexShrink: '0',
//             }} key={`sampleCard-${i}`} >
//                 <SvgMap />
//             </div>
//         )
// );

const TallOuterContainer = styled.div.attrs(({ dynamicHeight }) => ({
    style: { height: `${dynamicHeight}px` }
}))`
  position: relative;
  width: 100%;
`;

const StickyInnerContainer = styled.div`
  position: sticky;
  top: 0;
  height: 700px;
  width: 100%;
  overflow-x: hidden;
  background: #000000;
`;

const HorizontalTranslateContainer = styled.div.attrs(({ translateX }) => ({
    style: { transform: `translateX(${translateX}px)` }
}))`
  position: absolute;
  height: 100%;
  will-change: transform;
`;


function AboutUs(props) {
    const classesG = useGeneralStyles();
    const matchTablet = useMediaQuery('(min-width:600px)');
    const matchAboutUs = props.location.pathname.toUpperCase() === '/aboutUs'.toUpperCase();
    const [aboutUs, setAboutUs] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/about-us`)
            .then((response) => {
                setAboutUs(response.data);
                // console.log('ABOUTUS: ' + JSON.stringify(response.data));
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, []);


    const [dynamicHeight, setDynamicHeight] = useState(null);
    const [translateX, setTranslateX] = useState(0);

    const containerRef = useRef(null);
    const objectRef = useRef(null);


    const calcDynamicHeight = objectWidth => {
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        return objectWidth - vw + vh + 150;
    };

    const handleDynamicHeight = (ref, setDynamicHeight) => {
        var objectWidth;
        if (matchTablet === true && matchAboutUs === true) {
            objectWidth = 0;
        } else {
            if (ref.current === null || ref.current === 'null') {
                objectWidth = 0;
            } else {
                objectWidth = ref.current.scrollWidth;
            }

        }
        const dynamicHeight = calcDynamicHeight(objectWidth);
        setDynamicHeight(dynamicHeight);
    };

    const applyScrollListener = (ref, setTranslateX) => {
        window.addEventListener("scroll", () => {
            var offsetTop;
            if (matchTablet === true && matchAboutUs === true) {
                offsetTop = 0;
            } else {
                if (ref.current === null || ref.current === 'null') {
                    offsetTop = 0;
                } else {
                    offsetTop = -ref.current.offsetTop;
                }

            }
            setTranslateX(offsetTop);
        });
    };


    var resizeHandler;
    if (matchTablet === false && matchAboutUs) {
        resizeHandler = () => {
            handleDynamicHeight(objectRef, setDynamicHeight);
        };
    }

    useEffect(() => {
        if (matchTablet === false && matchAboutUs === true) {
            handleDynamicHeight(objectRef, setDynamicHeight);
            window.addEventListener("resize", resizeHandler);
            applyScrollListener(containerRef, setTranslateX);
        }
    }, []);


    const SampleCards = React.memo(() =>
        Array(1)
            .fill(0)
            .map((_e, i) =>
                <div style={{
                    position: 'relative',
                    height: '100%',
                    width: '1150px',
                    flexShrink: '0',
                }} key={`sampleCard-${i}`} >
                    {aboutUs === null || aboutUs === undefined ? '' : (
                        <img src={replace(aboutUs.Map_svg.url)} alt="map" />
                    )}
                </div>
            )
    );

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {aboutUs === null || aboutUs === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{aboutUs.Page_title}</title>
                                <meta name="description" content={aboutUs.Page_description} />
                            </MetaTags>

                            <div className={classesG.container}>
                                <section className={classesG.section}>
                                    <div className={classesG.aboutUsContainerSectionHome}>
                                        <img
                                            src={replace(aboutUs.Header_image.url)}
                                            alt="headerAboutus"
                                            className={classesG.aboutUsImageHome}
                                        />
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.aboutUsSecondSectionContent}>
                                        <div className={classesG.sectionBoxColumn}>
                                            <div className={classesG.aboutUssecondSectionText}>
                                                <h2>{aboutUs.Section_title}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: aboutUs.Section_text }} />
                                                <div>
                                                    <ul className={classesG.aboutUsList}>
                                                        {aboutUs.Statistics === null || aboutUs.Statistics.length === 0 || aboutUs.Statistics.length === '' ? '' :
                                                            aboutUs.Statistics.sort((a, b) => a.Order - b.Order).map((items, i) => (
                                                                <li key={i}>
                                                                    <h3>{items.Value}</h3>
                                                                    <span>{items.Name}</span>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                                <br />
                                                <br />
                                            </div>
                                        </div>

                                    </div>
                                </section>

                                {matchTablet ?
                                    <section className={classesG.section}>
                                        <div className={classesG.containerSectionHome}>
                                            {/* <SvgMap /> */}
                                            <img src={replace(aboutUs.Map_svg.url)} alt="map" />
                                        </div>
                                        <div className={classesG.aboutUsThirdSectionContent}>
                                            <div className={classesG.sectionBox}>
                                                <h2 className={classesG.aboutUsThirdTextH2}>Our Global Footprint</h2>
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    <React.Fragment>
                                        <section className={classesG.sectionAboutUs}>
                                            <div className={classesG.containerSectionHomeMobile}>
                                                {aboutUs === null || aboutUs === undefined || aboutUs === '' ? '' : (
                                                    <>
                                                        <Main>
                                                            <HorizontalSection>
                                                                <TallOuterContainer dynamicHeight={dynamicHeight}>
                                                                    <StickyInnerContainer ref={containerRef}>
                                                                        <HorizontalTranslateContainer translateX={translateX} ref={objectRef}>
                                                                            <CardsContainer>
                                                                                <SampleCards />
                                                                            </CardsContainer>
                                                                        </HorizontalTranslateContainer>
                                                                    </StickyInnerContainer>
                                                                </TallOuterContainer>
                                                            </HorizontalSection>
                                                        </Main>
                                                    </>
                                                )}

                                            </div>
                                        </section>
                                    </React.Fragment>
                                }



                                <section className={classesG.section}>
                                    <div className={classesG.fourSectionContent}>
                                        <div className={classesG.sectionBox}>
                                            <div className={classesG.aboutUsfourSectionText}>
                                                <h2>{aboutUs.Leadership_title}</h2>
                                                <div>
                                                    <ul className={classesG.aboutUsList_Op2}>

                                                        {aboutUs.Leaderships === null || aboutUs.Leaderships.length === 0 || aboutUs.Leaderships.length === '' ? '' :
                                                            aboutUs.Leaderships.sort((a, b) => a.Order - b.Order).map((items, i) => (
                                                                <li key={i}>
                                                                    <div>
                                                                        <img
                                                                            src={replace(items.Image.url)}
                                                                            alt={items.Name}
                                                                            className={classesG.imageHome}
                                                                        />
                                                                    </div>
                                                                    <h4>{items.Name}</h4>
                                                                    <p>{items.Position}</p>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.containerSectionHome} style={{ marginTop: '28px', }}>
                                        <img
                                            src={replace(aboutUs.Footer_image[0].url)}
                                            alt="Stadium"
                                            className={classesG.imageHome}
                                        />
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.aboutUsFourSectionContent}>
                                        <div className={classesG.aboutUsSectionBox}>
                                            <div className={classesG.aboutUsfourSectionText}>
                                                <h2>{aboutUs.Our_brands_title}</h2>
                                                <div>
                                                    <ul className={classesG.aboutUsList_Op3}>
                                                        {aboutUs.Our_brands_content.length === 0 || aboutUs.Our_brands_content.length === '' ? '' :
                                                            aboutUs.Our_brands_content.map((items, i) => (
                                                                <li key={i}>
                                                                    <div>
                                                                        <a href={items.Url} target="_blank" rel="noreferrer">
                                                                            <img
                                                                                src={replace(items.Black_image.url)}
                                                                                alt={items.Name}
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                    <p>{items.Description}</p>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (AboutUs);